module.exports = __webpack_public_path__ + "src/assets/textures/tractor/oil_stick.png";